import api from './api';
import {
    CounsellorData,
    UserAcademics,
    UserPreference,
    ShortlistedCollege,
    CollegeDetails,
    FileData
} from '../types/dashboard.types';

const dashboardService = {
    getCounsellorProfile: async () => {
        const response = await api.get<{ data: CounsellorData; message: string }>('/user-personal');
        return response.data;
    },
    getClients: async () => {
        const response = await api.get('clients');
        return response.data;
    },
    getUserAcademics: async (studentId: string) => {
        const response = await api.get<{ data: UserAcademics; message: string }>(`/user-academics/${studentId}`);
        return response.data;
    },
    getUserPreference: async (studentId: string) => {
        const response = await api.get<{ data: UserPreference; message: string }>(`/user-preference/${studentId}`);
        return response.data;
    },
    getShortlist: async (studentId: string) => {
        const response = await api.get<{ data: ShortlistedCollege[]; message: string }>(`/shortlist/${studentId}?type=college`);
        return response.data;
    },
    updateShortlistStatus: async (shortlistId: string, status: string, collegeId: string, userId: string) => {
        const response = await api.put(`/shortlist/${userId}`, { collegeId, status });
        return response.data;
    },
    getCollegeDetails: async (collegeIds: string[]) => {
        const queryCollegeIds = `[${collegeIds.join(',')}]`;
        const response = await api.get<{ data: CollegeDetails[]; message: string }>(`/college-list?collegeIds=${queryCollegeIds}`);
        return response.data;
    },
    getFileUrls: async (fileIds: string[]) => {
        const filterParam = fileIds.join(',');
        const response = await api.get<{ data: FileData[]; message: string }>(`/file/multi?filter=${filterParam}`);
        return response.data;
    }
};

export default dashboardService;
